import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef
} from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgClass } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';

@Component({
  selector: 'app-confirm-box',
  templateUrl: './confirm-box.component.html',
  styleUrls: ['./confirm-box.component.scss'],
  imports: [CdkScrollable, MatDialogContent, MatDialogActions, NgClass, MatButton, MatDialogClose, MatDivider]
})
export class ConfirmBoxComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ConfirmBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit(): void {}
}

export interface DialogData {
  title: string;
  alertMessage: string;
  confirmButton: string;
  hideCannotBeUndone?: boolean;
  biggerButtons?: boolean;
  hideCancel?: boolean;
}
